import { render, staticRenderFns } from "./topbarSaveBtn.vue?vue&type=template&id=1e463c04&"
import script from "./topbarSaveBtn.vue?vue&type=script&lang=js&"
export * from "./topbarSaveBtn.vue?vue&type=script&lang=js&"
import style0 from "./topbarSaveBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports